
  // Cart Size Display Updater
  // Handles displaying UK/US sizes in cart based on user preference

  class CartSizeDisplayManager {
    constructor() {
      this.init();
    }

    init() {
      // Update on page load
      this.updateCartSizeDisplay();

      // Listen for DOM changes (when cart drawer opens/updates)
      this.observeCartChanges();

      // Listen for size toggle changes
      document.addEventListener('size-toggle-changed', () => {
        this.updateCartSizeDisplay();
      });

      // Listen for storage changes (cross-tab sync)
      window.addEventListener('storage', (e) => {
        if (e.key === 'active-size') {
          this.updateCartSizeDisplay();
        }
      });

      // Listen for Shopify cart update events
      document.addEventListener('cart:updated', () => {
        // Small delay to ensure DOM is updated
        setTimeout(() => this.updateCartSizeDisplay(), 100);
      });

      // Listen for cart drawer open
      document.addEventListener('cart:open', () => {
        setTimeout(() => this.updateCartSizeDisplay(), 100);
      });
    }

    observeCartChanges() {
      // Watch for cart drawer and cart items being added to DOM
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.addedNodes.length) {
            // Check if cart-related elements were added
            const hasCartElements = Array.from(mutation.addedNodes).some((node) => {
              if (node.nodeType === 1) {
                // Element node
                return (
                  node.matches?.('[id*="cart"]') ||
                  node.querySelector?.('[id*="cart"]') ||
                  node.classList?.contains('cart-item') ||
                  node.querySelector?.('.cart-item')
                );
              }
              return false;
            });

            if (hasCartElements) {
              setTimeout(() => this.updateCartSizeDisplay(), 50);
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    updateCartSizeDisplay() {
      const activeSize = localStorage.getItem('active-size') || 'UK';
      const sizeDisplays = document.querySelectorAll('.cart-size-display');

      if (sizeDisplays.length === 0) {
        // Try again after a short delay if cart is still loading
        setTimeout(() => {
          const retryDisplays = document.querySelectorAll('.cart-size-display');
          if (retryDisplays.length > 0) {
            this.toggleSizeDisplays(retryDisplays, activeSize);
          }
        }, 200);
      } else {
        this.toggleSizeDisplays(sizeDisplays, activeSize);
      }
    }

    toggleSizeDisplays(displays, activeSize) {
      displays.forEach((display) => {
        const ukValue = display.querySelector('.size-uk-value');
        const usValue = display.querySelector('.size-us-value');

        if (!ukValue || !usValue) return;

        if (activeSize === 'US') {
          ukValue.classList.add('hidden');
          usValue.classList.remove('hidden');
        } else {
          ukValue.classList.remove('hidden');
          usValue.classList.add('hidden');
        }
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new CartSizeDisplayManager();
    });
  } else {
    new CartSizeDisplayManager();
  }
